import React from 'react';
import { getAsset } from '@/client/utils/assets';
import { deriveEntityStatus, entityStatusBadgeClass } from '@/client/utils/filters';

export const ListingGridView: React.FC<{
  entities: any[];
  onOpenDetail: (eid: number) => void;
}> = ({ entities, onOpenDetail }) => (
  <div className="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-6 gap-6">
    {entities.map(({ Assets, Entity, EntityType, Prices }) => {
      const status = deriveEntityStatus(Entity);
      return (
        <div key={Entity.eid} className="bg-white rounded-lg shadow overflow-hidden hover:shadow-lg transition-shadow">
          <div className="aspect-w-16 aspect-h-9">
            <img
              src={getAsset(Assets?.[0]) || '/api/placeholder/800/600'}
              alt={Assets?.[0]?.name || 'Entity image'}
              className="w-full h-full object-cover"
            />
          </div>
          <div className="p-4">
            <div className="flex justify-between items-start">
              <div>
                <h3 className="text-lg font-semibold text-gray-900">
                  {EntityType.name_friendly || EntityType.name_system}
                </h3>
                <p className="text-sm text-gray-500 line-clamp-2">{Entity.description}</p>
              </div>
            </div>

            <div className="mt-4">
              {Prices?.[0]?.price && (
                <div className="text-sm font-medium text-gray-900">
                  GHS {Prices?.[0]?.price.toLocaleString()}
                </div>
              )}
            </div>

            <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${entityStatusBadgeClass(status)}`}>
              {status.charAt(0) + status.slice(1).toLowerCase()}
            </span>

            <div className="mt-4 flex justify-end">
              <button
                onClick={() => onOpenDetail(Entity.eid)}
                className="text-blue-600 hover:text-blue-900 text-sm font-medium"
              >
                View Details
              </button>
            </div>
          </div>
        </div>
      );
    })}
  </div>
);
